import cacheKeys from '@/data/api/cacheKeys';
import { getCart } from '@/data/api/request/cartRequests';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

export function useGetCartDetails() {
  const [cartId, setCartId] = useState<string>();
  const query = useQuery({
    queryKey: [cacheKeys.carts.details, cartId],
    queryFn: () => getCart(cartId ?? ''),
    enabled: !!cartId?.trim(),
  });

  return { ...query, setCartId };
}
